module.exports = __webpack_public_path__ + "img/block-l-3.f937b45a.png";